import type React from "react";
import type { HTMLAttributes } from "react";

import { Root } from "./styles";

type TableProps = {
  /**
   * Display vertical borders on the table
   */
  isBordered?: boolean;
  /**
   * Display alternative colours on table body rows
   */
  isStriped?: boolean;
  /**
   * Highlight the head and foot rows of the table
   */
  isHeaderHighlighted?: boolean;
} & HTMLAttributes<HTMLTableElement>;

/**
 *  Standard HTML table styled to the JDS theme
 */
export function Table({
  isBordered = true,
  isStriped = false,
  isHeaderHighlighted = true,
  children,
  ...rest
}: TableProps) {
  return (
    <Root
      $isBordered={isBordered}
      $isStriped={isStriped}
      $isHeaderHighlighted={isHeaderHighlighted}
      data-testid={Table.name}
      {...rest}
    >
      {children}
    </Root>
  );
}
